import { Instant } from '@js-joda/core';
import { DataEntitiesReportsReportType } from '../shared/api/axios-client';

export const parseInstant = (dateStr: string | null | undefined): Instant | null => {
    if (!dateStr) return null;
    try {
        const normalizedDate = dateStr.endsWith('Z') || /[+-]\d{2}:?\d{2}$/.test(dateStr) 
            ? dateStr 
            : `${dateStr}Z`;
        return Instant.parse(normalizedDate);
    } catch (e) {
        console.error('Error parsing date:', e, dateStr);
        return null;
    }
};

export const getClientTimezone = (): string => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
        console.error('Error getting client timezone:', e);
        return 'UTC';
    }
};

export enum reportTypes {
  payment = 0,
  subscription = 1,
  aging = 2,
  redeemedvalidation = 3
}

export const getReportTypeEnum = (type: string): reportTypes => {
  const key = type.trim().toLowerCase() as keyof typeof reportTypes;
  return reportTypes[key] ?? reportTypes.payment; 
};

export const reportTypeLabels: Record<number, string> = {
  [reportTypes.payment]: "Payment",
  [reportTypes.subscription]: "Subscription",
  [reportTypes.aging]: "Aging",
  [reportTypes.redeemedvalidation]: "Redeemed Validation",
};